"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _View = _interopRequireDefault(require("react-native-web/dist/cjs/exports/View"));
var _StyleSheet = _interopRequireDefault(require("react-native-web/dist/cjs/exports/StyleSheet"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ThemeProvider = require("../ThemeProvider");
var _Typography = _interopRequireDefault(require("../Typography"));
var _utils = require("../utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const fontSizeMapping = {
  12: 'micro',
  14: 'small',
  16: 'h6'
};
const [selectProps, selectedSystemPropTypes] = (0, _utils.selectSystemProps)([_utils.htmlAttrs, _utils.viewProps]);
const selectContainerBackground = _ref => {
  let {
    backgroundColor
  } = _ref;
  return {
    backgroundColor
  };
};
const selectContainerBorder = _ref2 => {
  let {
    borderWidth,
    borderColor,
    borderRadius
  } = _ref2;
  return {
    borderWidth,
    borderColor,
    borderRadius
  };
};
const selectContainerPadding = _ref3 => {
  let {
    paddingTop,
    paddingRight,
    paddingBottom,
    paddingLeft
  } = _ref3;
  return {
    paddingTop,
    paddingRight,
    paddingBottom,
    paddingLeft
  };
};
const getTypographyTokens = _ref4 => {
  let {
    fontName,
    fontWeight,
    color
  } = _ref4;
  return {
    fontName,
    fontWeight,
    color
  };
};
const getTypographyVariant = _ref5 => {
  let {
    fontSize
  } = _ref5;
  return {
    size: fontSizeMapping[fontSize]
  };
};
const Badge = /*#__PURE__*/_react.default.forwardRef((_ref6, ref) => {
  let {
    children,
    tokens,
    variant = {},
    ...rest
  } = _ref6;
  const themeTokens = (0, _ThemeProvider.useThemeTokens)('Badge', tokens, variant);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
    ref: ref,
    style: [staticStyles.container, selectContainerBackground(themeTokens), selectContainerBorder(themeTokens), selectContainerPadding(themeTokens)],
    ...selectProps(rest),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
      tokens: getTypographyTokens(themeTokens),
      variant: getTypographyVariant(themeTokens),
      children: children
    })
  });
});
Badge.propTypes = {
  ...selectedSystemPropTypes,
  children: _propTypes.default.node,
  tokens: (0, _utils.getTokensPropType)('Badge'),
  variant: _utils.variantProp.propType
};
Badge.displayName = 'Badge';
var _default = exports.default = Badge;
const staticStyles = _StyleSheet.default.create({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignSelf: 'flex-start'
  }
});